import React, { useEffect,useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ProtectedLayout from "../admin/component/ProtectedLayout";
import Sidebar from "../admin/Sidebar";
import TopHeader from "../admin/TopHeader";
import Dashboard from "../admin/Dashboard";
import VendorMangement from "../admin/vendor/VendorMangement";
import ListCategory from "../admin/Category/ListCategory";
import ListProducts from "../admin/products/ListProduct";
import ViewProduct from "../admin/products/ViewProduct";
import OrderRecevied from "../admin/order/OrderRecevied";
import Adduser from "../admin/user/Adduser";
import OrderDetails from "../admin/order/OrderDetails";
import VendorReport from "../admin/vendor/VendorReport";
import Banner from "../admin/banner/List";
import Location from "../admin/location/Location";
import Customer from "../admin/customer/Listcustomer";
import CustomerOrders from "../admin/customer/CustomerOrders";
import CustomerOrderDetails from "../admin/customer/CustomerOrderDetails";
import VendorReportDetail from "../admin/vendor/VendorReportDetail";
import PayoutReport from "../admin/vendor/PayoutReport";
import Reports from "../admin/report/Reports";
import VendorDetail from "../admin/vendor/VendorDetailView";
import VendorNotification from "../admin/notification/VendorNotification";
import UserNotification from "../admin/notification/UserNotification";

const AdminApp = () => {
  const dispatch = useDispatch();
  const [deliveryMode, setDeliveryMode] = useState("delivery"); 

  return (
    <ProtectedLayout>
      <div className="tap-top">
        <i data-feather="chevrons-up" />
      </div>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-header">
          <TopHeader 
          deliveryMode={deliveryMode} 
          onModeChange={setDeliveryMode} 
        />
        </div>
        <div className="page-body-wrapper mt-4">
          <Sidebar />
          <div className="page-body">
            <Routes>
              <Route path="/" element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="VendorMangement" element={<VendorMangement />} />
                        <Route path="category" element={<ListCategory />} />
             
              <Route path="products" element={<ListProducts />} />
              <Route path="order/recevied" element={ <OrderRecevied 
      deliveryMode={deliveryMode} 
      onModeChange={setDeliveryMode} 
    />} />
              <Route path="banner" element={<Banner />} />
              <Route path="settings/Users" element={<Adduser />} />
              <Route path="orders/details/:id" element={<OrderDetails/>} />
            <Route path="/VendorReports/:id" element={<VendorReportDetail />} />
          <Route path="/VendorManagement/:id" element={<VendorDetail />} />
              <Route path="products/view/:id" element={<ViewProduct />} />
            <Route path="/PayoutReport" element={<PayoutReport />} />
              <Route path="/VendorReports" element={<VendorReport />} />
              <Route path="/location" element={<Location />} />
              <Route path="/customer" element={<Customer />} />
              <Route path="/customers/:id/orders" element={<CustomerOrders />} />
              <Route path="/customer/details/:id" element={<CustomerOrderDetails />} />
           <Route path="notification/vendor" element={<VendorNotification/>} />
<Route path="notification/Users" element={<UserNotification />} />
          <Route path="/reports" element={<Reports />} />
            </Routes>
          </div>
          <footer className="footer">
            <div className="container-fluid" style={{ marginBottom: "0px" }}>
              <div className="row">
                <div className="col-md-12 footer-copyright text-center">
                <p className="mb-0">
  Copyright {new Date().getFullYear()} © Tamigo
</p>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </ProtectedLayout>
  );
};

export default AdminApp;